import { OfferTypeEnum } from "./offerType";

class OfferTypeHelper {

    public isCash(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType === OfferTypeEnum.Cash || offerType === OfferTypeEnum.CashMinPrice;
    }

    public isHta(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType === OfferTypeEnum.Hta || offerType === OfferTypeEnum.HtaMinPrice;
    }

    public isBasis(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer].includes(offerType);
    }

    public isPriceLockAllowed(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis].includes(offerType);
    }

    public hasFuturesPrice(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.BushelOnlyContract, OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis].includes(offerType);
    }

    public hasBasis(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.BushelOnlyContract, OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice, OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer].includes(offerType);
    }

    public originatesFromOffer(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.BasisOffer, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis, OfferTypeEnum.FixBasisOnHta].includes(offerType);
    }

    public canHaveDelayedPriceContract(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer].includes(offerType);
    }

    public canBeHedged(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && ![OfferTypeEnum.DelayedPriceContract, OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer, OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.BushelOnlyContract].includes(offerType);
    }

    public canBuyNow(offerType: Nullish<OfferTypeEnum>): boolean {
        return offerType != null && [OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice, OfferTypeEnum.Hta, OfferTypeEnum.HtaMinPrice].includes(offerType);
    }
}

const offerTypeHelper = new OfferTypeHelper()

export default offerTypeHelper;